const PRODUCTION = process.env.NODE_ENV === 'production'

// export const API_PATH = PRODUCTION ? 'https://api.blayzr.com/api/v1' : '/api/v1'
export const API_PATH = 'https://api.blayzr.com/api/v1'

const PICASSO_SOCKET_PRODUCTION = window.location.host === 'blayzr.com' ? 'wss://picasso.blayzr.com/ws' : 'ws://ec2-52-208-98-63.eu-west-1.compute.amazonaws.com:8888/ws'
export const PICASSO_SOCKET = PRODUCTION ? PICASSO_SOCKET_PRODUCTION : 'ws://localhost:8888/ws'

export const ORCHESTRA_SOCKET = PRODUCTION ? 'wss://api.blayzr.com:8765' : 'ws://localhost:8765'
export const ORCHESTRA_SOCKET_2 = PRODUCTION ? 'wss://api.blayzr.com:8766' : 'ws://localhost:8766'
export const ORCHESTRA_TV_SOCKET = PRODUCTION ? 'wss://api.blayzr.com:8865' : 'ws://localhost:8865'
export const ORCHESTRA_TV_SOCKET_2 = PRODUCTION ? 'wss://api.blayzr.com:8866' : 'ws://localhost:8866'
export const ORCHESTRA_PLAYER_HOST = PRODUCTION ? 'http://player.blayzr.com.s3-website-eu-west-1.amazonaws.com' : 'http://localhost:8080'
export const ORCHESTRA_PLAYER_JOIN_PATH = ORCHESTRA_PLAYER_HOST + '/join/:id'
export const ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH = ORCHESTRA_PLAYER_HOST + '/join-with-code/:code'

export const SUPER_ADMINS = [ 1, 3, 38 ] // Hardcoded superadmin user IDs

export const ENDPOINT_LOGIN = '/user/login'
export const ENDPOINT_SHARING = '/sharing/:code'
export const ENDPOINT_FETCH_EXTERNAL_SHARES = '/sharing/all'
export const ENDPOINT_EXTEND_EXTERNAL_SHARE = '/tokens/sharing/extend/:code'
export const ENDPOINT_REFRESH_TOKENS = '/refresh/session'
export const ENDPOINT_REFRESH_AWS = '/refresh/aws'
export const ENDPOINT_ALBUMS = '/albums'
export const ENDPOINT_FAVOURITE_ALBUMS = '/favourites'
export const ENDPOINT_ALBUM = '/album/:id'
export const ENDPOINT_NEW_ALBUM = '/album'
export const ENDPOINT_IMAGE_SEARCH = '/search'
export const ENDPOINT_IMAGE = '/image/:id'
export const ENDPOINT_FLAG_IMAGE = '/image/:id/flag'
export const ENDPOINT_RATE_IMAGE = '/image/:id/rate/:rating'
export const ENDPOINT_HIERARCHY = '/albums/hierarchy'
export const ENDPOINT_KEYWORD_PARENTS = '/keywords/parents'
export const ENDPOINT_KEYWORD_HIERARCHY = '/keywords/hierarchy'
export const ENDPOINT_KEYWORD_GRAPH = '/graph'
export const ENDPOINT_SET_FAVOURITE_ALBUM = '/favourite/album/:id'
export const ENDPOINT_USERS = '/users'
export const ENDPOINT_USER = '/user/:id'
export const ENDPOINT_NEW_USER = '/user/create'
export const ENDPOINT_PERMS = '/perms'
export const ENDPOINT_FETCH_ALBUM_SHARE = '/album/:id/share'
export const ENDPOINT_ALBUM_SHARE = '/album/:album_id/share/user/:user_id'
export const ENDPOINT_SHARE_CODE = '/tokens/sharing'
export const ENDPOINT_PLAYLISTS = '/playlists'
export const ENDPOINT_PLAYLIST = '/playlist/:id'
export const ENDPOINT_NEW_PLAYLIST = '/playlist'
export const ENDPOINT_QUEUES = '/queues'
export const ENDPOINT_QUEUE = '/queue/:id'
export const ENDPOINT_NEW_QUEUE = '/queue'
export const ENDPOINT_DYNAMIC_LINKS = '/dynamic_links'
export const ENDPOINT_DYNAMIC_LINK = '/dynamic_link/:id'
export const ENDPOINT_NEW_DYNAMIC_LINK = '/dynamic_link'
export const ENDPOINT_SHARE_IMAGES = '/images/share/:user_id'
export const ENDPOINT_LIBRARIES = '/libraries'
export const ENDPOINT_LIBRARY = '/library/:id'
export const ENDPOINT_NEW_LIBRARY = '/library'
export const ENDPOINT_GLOBAL_SETTINGS = '/settings/global'
export const ENDPOINT_ALBUM_PATH_COUNTS = '/album_paths'
export const ENDPOINT_CONFIG = '/config'
export const ENDPOINT_PRESENT_TOKEN = '/present/token'
export const ENDPOINT_ORCHESTRA_TOKEN = '/orchestra/token'
export const ENDPOINT_PICASSO = '/picasso'
export const ENDPOINT_AGGREGATION = '/search/aggregations'
export const ENDPOINT_SCRIPTS_INFO = '/services_info'
export const ENDPOINT_USER_SESSIONS = '/user/:id/sessions'
export const ENDPOINT_ALL_USER_SESSIONS = '/users/sessions'
export const ENDPOINT_LOGOUT_ALL = '/user/logout'

export const AUTH_COOKIE_KEY = 'auth'
export const AUTH_COOKIE_EXPIRY = 86400 // seconds
export const REFRESH_TOKENS_DELAY = 10 // seconds

export const AWS_BUCKET = 'blayzr-processed'
export const AWS_EXPIRY_TIME = 86400 // seconds

export const QUERY_CACHE_KEY = 'query-cache'
export const QUERY_CACHE_EXPIRY = 60 // One hour
export const SETTINGS_CACHE_KEY = 'settings'
export const KEYWORD_VISIBILITY_CONFIG_KEY = 'keyword-visibility'
export const KEYWORD_WEIGHTING_CONFIG_KEY = 'keyword-weighting'
export const KEYWORD_IGNORE_FILTER_PREFIX = 'Tag-'

export const AUTOCOMPLETE_MINIMUM_CHARACTERS = 2
export const AUTOCOMPLETE_PAGE_SIZE = 10

export const DOUBLE_TAP_ZOOM_LEVEL = 2 // Amount to zoom image on double tap

export const IMAGE_SIZES = {
  t75: 240,
  s75: 640,
  m75: 1024,
  l75: 1920
}

// NOTE: The variants here must be kept in sync with the scripts config: /scripts/config.py.sample
export const IMAGE_VARIANTS = ['i100', 't75', 's75', 'm75', 'l75', 'o']
export const DEFAULT_SETTINGS = {
  aws: true,
  imagePath: '',
  iconVariant: 'i100',
  thumbVariant: 't75',
  displayVariant: 's75',
  presentVariant: 's75'
}

export const PRIMARY_COLOR = '#144450'
export const MOBILE_BREAKPOINT = 768
export const MAX_FIXED_COUNT = 2000 // Maximum number of images for fixed album

export const MAPS_API_KEY = 'AIzaSyAUXuR7UzbaNhIGm8dE-9ygdKumMDb4EWs'
export const MAPS_API_CALLBACK = 'mapsReady'
export const MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&callback=${MAPS_API_CALLBACK}`
export const GEO_LOOKUP_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

// http://openweathermap.org/current
export const WEATHER_API_KEY = '197dd4cf16bfdf371af9b5bfe6a9c060'
export const WEATHER_REFRESH_INTERVAL = 30 * 1000

// http://openweathermap.org/weather-conditions
export const WEATHER_ARRAY = ['Clear', 'Clouds', 'Drizzle', 'Rain', 'Thunderstorm', 'Snow']

export const DYNAMIC_ALBUMS = {
  'on-this-day': 'On This Day',
  'recent': 'Recent Pictures'
}

export const MONTH_ARRAY = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const DEFAULT_START_DATE = '1900-01-01'
export const AUTO_PLAYLIST_SUFFIX = ' (autoplaylist)'

export const PRESENTATION_ARRAY = [
  { value: 'kenburns', name: 'Ken Burns' },
  { value: 'floating', name: 'Floating' }
]

export const SORT_ARRAY = [
  { value: 'relevance', name: 'Relevance' },
  { value: 'rating-asc', name: 'Rating (asc)' },
  { value: 'rating-desc', name: 'Rating (desc)' },
  { value: 'date-asc', name: 'Date (asc)' },
  { value: 'date-desc', name: 'Date (desc)' },
  { value: 'filename-asc', name: 'Filename (asc)' },
  { value: 'filename-desc', name: 'Filename (desc)' },
  { value: 'manual', name: 'Manual' },
  { value: 'random', name: 'Random' }
]

export const UNKNOWN_SEASON = '6. Unknown Season'
export const YEAR_SELECTS = '7. Year Selects'
export const TIMELINE_SEASONS = [
  '1. Winter (Year Start)',
  '2. Spring',
  '3. Summer',
  '4. Autumn',
  '5. Winter (Year End)',
  UNKNOWN_SEASON,
  YEAR_SELECTS
]

export const FIX_WARNING = 'Locking an album will fix the album to the current set of images. Editing will be disabled until the album is unlocked. Are you sure you want to continue?'
export const UNFIX_WARNING = 'Unlocking an album will reset the album back to the original search query, new images may appear in your album. Are you sure you want to continue?'

export const SPECIAL_ALBUM_PATH_TITLE = {
  'null': 'Images Without Album Path',
  'event:null': 'Images Without Event Path',
  'keyword:null': 'Images Without Keywords'
}

export const IS_IOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent)



// WEBPACK FOOTER //
// ./src/constants.js